import { render, staticRenderFns } from "./rankFinal3round2.vue?vue&type=template&id=9ece98cc&scoped=true"
import script from "./rankFinal3round2.vue?vue&type=script&lang=js"
export * from "./rankFinal3round2.vue?vue&type=script&lang=js"
import style0 from "./rankFinal3round2.vue?vue&type=style&index=0&id=9ece98cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ece98cc",
  null
  
)

export default component.exports